import browserFn from "../utils/browser";
const browser = browserFn();

const sogou = browser.versions && browser.versions.sogou; // 是否搜狗浏览器
const quark = browser.versions && browser.versions.quark; // 是否夸克浏览器

if (!(sogou || quark)) {
  // 巨量平台热力图埋码
  (function(r, d, s) {
    r._tt_config = true;
    var _baq = (r._baq = r._baq || []);
    _baq.methods = ["track", "off", "on"];
    _baq.factory = function(method) {
      return function() {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        _baq.push(args);
        return _baq;
      };
    };
    for (var i = 0; i < _baq.methods.length; i++) {
      var key = _baq.methods[i];
      _baq[key] = _baq.factory(key);
    }
    _baq.load = function() {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      js = d.createElement(s);
      js.src = "https://analytics.oceanengine.com/api/v2/js/sdk";
      fjs.parentNode.insertBefore(js, fjs);
    };
    _baq.load();
    if (_baq.invoked) {
      return;
    }
    _baq.invoked = true;
    _baq.track("pageview");
  })(window, document, "script");

  // 落地页洞察代码，启用后将采集您的页面访问数据，但不会收集用户隐私信息
  // @ts-ignore
  window._baq.on("insight");
}
